import Vue from "vue";
import NotificationMonitor from "./notification-monitor.vue"

const onReady = function () {
  
  if ((window as any).ONE_STOP) {
    const $rootElements = $("div[data-vue-notification-monitor]");

    $rootElements.each((ind, el) => {
      new Vue({
        el: el,
        render: h => h(NotificationMonitor),
      })
    });
  }
};


$(onReady);